import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux/es/exports';
import { getRemoveTodos } from "../asyncActions/getRemovedTodos";
import { loadRunTimeResults } from "../store/RunTimeTaskResults/RunTimeResults";
// import GroupChangeMenu from "../GroupTaskEditing/GroupChangeMenu";
import TodoList from "./TodosList";
import Loader from "../Loader/Lodaer";
import { ReactComponent as ModalTitleImg } from "../icons/svg/remove-task-hover.svg";
import { addOnContextState } from "../store/contextMenuTaskReducer";
import PaginationBtn from "../UIcomponents/PaginationBtn/PaginationBtn";


export default function TodoListRemoved({setIcon})  {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const todosRemoved = useSelector(state => state.todosRemoved.todosRemoved);
    const [dataLoad, setDataLoad] = useState({pageSize: 10, pageIndex: 1});
    const [hasNextPage, setHasNextPage] = useState(true);
    const paginationBtnData = {
        title: 'Показать еще'
    }
    useEffect(() => {
        const resetPageIndex = () => {
            setDataLoad({...dataLoad, pageIndex: 1})
        }

        window.addEventListener('beforeunload', resetPageIndex)

        return () => {
            window.removeEventListener('beforeunload', resetPageIndex)
        }
    }, [dataLoad])

    useEffect(() => {
        dispatch(getRemoveTodos(dataLoad, setHasNextPage))
        .then(() => setLoading(false))
        setIcon(<ModalTitleImg style={{width: '14px'}}/>)
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [getRemoveTodos, dataLoad])

    return (
            <div className="todo-list">
                <div className="todo-list__container">
                    {loading && <Loader></Loader>}
                    <div id='todosMenu' className="task-actions-container to_the_end">
                        {/* <GroupChangeMenu /> */}
                    </div>
                    <ul className="todo-list__list">
                        {todosRemoved.length ? (<div>
                            {todosRemoved.map((todos, index) => {
                                dispatch(loadRunTimeResults({isValue: false, taskId: todos.id}))
                                dispatch(addOnContextState({contextIsOpen: false, contextTaskId: todos.id}))
                                return <TodoList
                                            restoreBtn
                                            disableContextMenu
                                            todos={todos}
                                            disabled
                                            fromRemoved
                                            dyblicateTaskToday 
                                            key={index} />
                            }) }
                            {
                                hasNextPage ?
                                <div className="page_pagination">
                                    <PaginationBtn paginationBtnData={paginationBtnData} startIndex={dataLoad} handleClick={setDataLoad}></PaginationBtn>
                                </div>
                                : null
                            }
                            </div>) : loading ? null : (<p className="todo-list__is-null">В Вашей корзине пока что пусто</p>)}
                    </ul>
                </div>
            </div>
    )
    }